import { render, staticRenderFns } from "./UnLiker.vue?vue&type=template&id=985169ae&lang=pug&"
import script from "./UnLiker.vue?vue&type=script&lang=js&"
export * from "./UnLiker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports